module.exports = __webpack_public_path__ + "media/images/icon_a9_blue-0278c9bc54746c9c2e281e5088b2c2ac.png";